
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Tokens.Server.Plugins.Web
//----------------------------------------------------------


/// <amd-module name="TFS/Token/PatTokenPage/Generated/Contracts" />
export interface PatTokenPageData {
    aadTenantName: string;
    coreScopeGroupings: string[];
    getTokenPageSize: number;
    scopes: { [key: string]: ScopeGrouping; };
    userCanCreateFullScopedTokens: boolean;
    userCanCreateGlobalTokens: boolean;
    userCanCreateUnlimitedLifespanTokens: boolean;
    userTokenLifespanLimitInDays: number;
}

export interface ScopeData {
    grouping: string;
    inheritsFrom: string;
    key: string;
    name: string;
}

export interface ScopeGrouping {
    description: string;
    key: string;
    name: string;
    scopes: ScopeData[];
}

